
export class LoginUser {
  public LastName: string = "";
  public FirstName: string = "";
  public Id: number = 0;
  public WorkGroupId: number[];
  public WorkGroupName: string;
  public CountryHomeId: number = 0;
  //public CountryHome:Country;  
  public CountryId: number[];
  public CountryName: string;
  public ModuleId: number[];
  public OrgnizationalUnitId: number = 0;
  public OrgnizationalUnit: string;
  public SgId: string = "";
  public Email: string;
  public IsActive: boolean
  public Token: string;
  public RefreshToken: string;
  //public menuItemsForUser: NavigationMenuItem[];
  // public Countries: Country[];
  // public AssignedCountries: Country[];
  // public Roles: Role[];
  // public Modules:Module[];
  // public SubModules:SubModule[];
  // public SwitchUsers:User[]=[];
}
